import { useToast } from '~/composables/use-toast';

export const useNotifyResource = () => {
  const { success, error } = useToast();

  const notifySuccess = () => {
    success({ message: 'Done!' });
  };

  const notifyFailure = (message: string = 'Something went wrong!') => {
    error({ message });
  };

  return { notifySuccess, notifyFailure };
};
